module.exports = __webpack_public_path__ + "img/send.2d5dd6c3.svg";